import { Center, Spinner } from '@chakra-ui/react'
import { useActiveContentContext } from '@src/contexts/ActiveContentContext'
import { useCurrentUser } from '@src/hooks/useCurrentUser'
import { useUniversalEffect } from '@src/hooks/useUniversalEffect'
import { useRouter } from 'next/navigation'
import { useEffect } from 'react'

export { getServerSideProps } from '@src/lib/server-side-rendering'

export default function Page() {
  const router = useRouter()
  const { currentUser } = useCurrentUser()
  const activeContent = useActiveContentContext()

  useUniversalEffect(() => {
    activeContent.setSiteSection('signup.landing')
  })

  useEffect(() => {
    if (currentUser?.isRegistered) {
      router.push('/accelerator/profile')
    } else {
      router.push('/accelerator/register')
    }
  }, [])

  return (
    <Center>
      <Spinner />
    </Center>
  )
}
